import { Button } from "@chakra-ui/react";
import React from "react";
import BeatLoader from "react-spinners/BeatLoader";

const DynamicButton = ({
  onClickHandler,
  buttonText,
  isLoading,
  colorMain,
  isDisabled,
}) => {
  return (
    <Button
      onClick={onClickHandler}
      type="submit"
      position="relative"
      borderColor="teal.200"
      w="100%"
      bg={colorMain}
      color="white"
      align="center"
      fontSize={["14px", "14px", "17px"]}
      p="19px"
      mb={8}
      isDisabled={isDisabled || false}
      py={7}
      borderRadius="xl"
      shadow="base"
      fontWeight="bold"
      isLoading={isLoading}
      colorScheme="blue"
      spinner={<BeatLoader size={8} color="teal" />}
      _hover={{
        bg: "white",
        color: colorMain,
        borderColor: colorMain,
        borderWidth: "1px",
      }}
      _active={{
        bg: "white",
        color: colorMain,
        borderColor: colorMain,
        borderWidth: "1px",
      }}
    >
      {buttonText}
    </Button>
  );
};

export const PayButton = ({
  colorMain,
  number,
  phoneLength,
  amount,
  name,
  buttone,
  selection,
  trigger,
  handlePayment,
  buttonDisable,
  isAddButtonDisabled,
  isSelectButtonDisabled,
  buttonText = "Pay Now"
}) => {
  const isButtonDisabled =
    number?.length === phoneLength && name && buttonDisable(buttone, selection)
      ? false
      : true;

  return (
    <Button
      onClick={handlePayment}
      bgColor={colorMain}
      type="submit"
      color="white"
      align="center"
      p="18px"
      letterSpacing="wider"
      borderRadius="xl"
      boxShadow="base"
      fontWeight="bold"
      isDisabled={isButtonDisabled || isAddButtonDisabled || isSelectButtonDisabled}
      mb={6}
      w="100%"
      isLoading={trigger}
      px={16}
      fontSize="xl"
      spinner={<BeatLoader size={8} color="teal" />}
      _hover={{
        bg: "white",
        color: colorMain,
        border: `2px solid ${colorMain}`,
      }}
      _active={{
        bg: "white",
        color: colorMain,
        border: `2px solid ${colorMain}`,
      }}
    >
      {buttonText}
    </Button>
  );
};

export const ActionButton = ({
  onClick,
  text,
  isLoading,
  isDisabled,
  colorMain,
  spinnerColor,
}) => {
  return (
    <Button
      bgColor={colorMain}
      onClick={onClick}
      type="submit"
      color="white"
      align="center"
      p="18px"
      letterSpacing="wider"
      w="100%"
      borderRadius="xl"
      px={16}
      fontSize="xl"
      boxShadow="base"
      fontWeight="bold"
      isDisabled={isDisabled}
      mb={6}
      isLoading={isLoading}
      spinner={<BeatLoader size={8} color={spinnerColor} />}
      _hover={{
        bg: "white",
        color: colorMain,
        border: `2px solid ${colorMain}`,
      }}
      _active={{
        bg: "white",
        color: colorMain,
        border: `2px solid ${colorMain}`,
      }}
    >
      {text}
    </Button>
  );
};

export const OptionsButton = ({
  colorMain,
  buttonText,
  isLoading,
  onClick,
  isDisabled,
}) => {
  return (
    <Button
      type="submit"
      loadingText="updating"
      h="38"
      w="100%"
      mb="5px"
      fontSize={["md", "xl"]}
      borderRadius="xl"
      bg={colorMain}
      color="white"
      mt="4px"
      fontWeight="bold"
      isLoading={isLoading}
      spinner={<BeatLoader size={8} color="white" />}
      variant="outline"
      _hover={{
        color: colorMain,
        bg: "white",
      }}
      _active={{
        bg: "teal.400",
      }}
      onClick={onClick}
      isDisabled={isDisabled}
    >
      {buttonText}
    </Button>
  );
};

export default DynamicButton;
